import { render } from "./JourneyPage.vue?vue&type=template&id=0ac86360"
import script from "./JourneyPage.vue?vue&type=script&lang=js"
export * from "./JourneyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__